import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 sm:py-32 bg-[#f1f5f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#e02329] mb-3">Testimonials</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1c4f9c]">
            What our commercial clients say
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} data-testid={`testimonial-${i}`} className="bg-white border border-slate-200 rounded-sm p-8 relative">
              <Quote className="absolute top-6 right-6 text-slate-100" size={48} />
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={18} className="fill-[#e02329] text-[#e02329]" />
                ))}
              </div>
              <p className="relative text-base text-slate-700 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-slate-100">
                <p className="font-bold text-[#1c4f9c] text-sm">{t.author}</p>
                <p className="text-sm text-slate-500">{t.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
